//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getStockState: 'product/isInStock',
      getProductPrice: 'product/priceFromSku',
      getMinimumPartPrice: 'product/minimumPartPrice'
    }),
    pageId () {
      return parseInt((this.pageData.content || '').replace(/<[^>]*>/g, ''))
    },
    pageMode () {
      return [
        'lenskits',
        'cases',
        'goggleparts',
        'limitededition',
        'paceparts',
        'signatureseries'
      ][this.pageId - 1] || 'lenskits'
    },
    groupedProducts () {
      let groups = []

      if (this.pageMode === 'lenskits') groups.push({
        title: 'Lens Kits',
        subtitle: 'Sunglasses',
        products: [{
          title: 'Sierras™ Lens Kits',
          sku: 'sierraslrk-sle_Prose',
          part: 'sle',
          dynamicImg: true,
          link: '/shop/lenses/sierras'
        }, {
          title: 'Classics³ Lens Kits',
          sku: 'classics3lrk-c3le_Pgreen',
          part: 'c3le',
          dynamicImg: true,
          link: '/shop/lenses/classics3'
        }, {
          title: 'Renegades™ Lens Kits',
          sku: 'renegadeslrk-rgle_Pblue',
          part: 'rgle',
          dynamicImg: true,
          link: '/shop/lenses/renegades'
        }, {
          title: 'Vulcans™ Lens Kits',
          sku: 'vulcanslrk-vcle_8green',
          part: 'vcle',
          dynamicImg: true,
          link: '/shop/lenses/vulcans'
        }, {
          title: 'Airas™ Lens Kits',
          sku: 'airaslrk-ale_8fire',
          part: 'ale',
          dynamicImg: true,
          link: '/shop/lenses/airas'
        }, {
          title: 'Velans™ Lens Kits',
          sku: 'velanslrk-vele_8silverblue',
          part: 'vele',
          dynamicImg: true,
          link: '/shop/lenses/velans'
        }]
      })

      if (this.pageMode === 'cases') groups.push({
        title: 'Capsule Cases',
        subtitle: 'Sunglasses & Goggles',
        products: [{
          title: 'Sunglasses Capsule Case',
          subtitle: 'For: Classics³, Renegades™ & Sierras™',
          sku: 'case-ct_capsule',
          dynamicImg: true,
          link: '/shop/cases/capsule',
          fixedPrice: true
        }, {
          title: 'Pace Series™ Capsule Case',
          subtitle: 'For: Vulcans™, Airas™ & Velans™',
          sku: 'case-ct_pacecapsule',
          dynamicImg: true,
          link: '/shop/cases/pacecapsule',
          fixedPrice: true
        }, {
          title: 'Snow Series™ Capsule Case',
          subtitle: 'For: Snipers™ & Vanguards™',
          sku: 'case-ct_revoltcapsule',
          dynamicImg: true,
          link: '/shop/cases/snowcapsule',
          fixedPrice: true
        }]
      })

      if (this.pageMode === 'goggleparts' || this.pageMode === 'lenskits') groups.push({
        title: 'Lens & Replacement Parts',
        subtitle: 'Goggles',
        products: [{
          title: 'Vanguards™ Lens Kits',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'vanguardsparts-vf_none-vle_greenN-vs_none',
          part: 'vle',
          link: '/shop/parts/vanguards?id=vanguardsparts-vf_none-vle_greenN-vs_none'
        }, {
          title: 'Vanguards™ Frames',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'vanguardsparts-vf_blackM-vle_none-vs_none',
          part: 'vf',
          link: '/shop/parts/vanguards?id=vanguardsparts-vf_blackM-vle_none-vs_none'
        }, {
          title: 'Vanguards™ Straps',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'vanguardsparts-vf_none-vle_none-vs_blackwhiteL',
          part: 'vs',
          link: '/shop/parts/vanguards?id=vanguardsparts-vf_none-vle_none-vs_blackwhiteL'
        }, {
          title: 'Snipers™ Lens Kits',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'snipersparts-snf_none-snle_pinkN-sns_none',
          part: 'snle',
          link: '/shop/parts/snipers?id=snipersparts-snf_none-snle_pinkN-sns_none'
        }, {
          title: 'Snipers™ Frames',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'snipersparts-snf_blackM-snle_none-sns_none',
          part: 'snf',
          link: '/shop/parts/snipers?id=snipersparts-snf_blackM-snle_none-sns_none'
        }, {
          title: 'Snipers™ Straps',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'snipersparts-snf_none-snle_none-sns_blackwhiteL',
          part: 'sns',
          link: '/shop/parts/snipers?id=snipersparts-snf_none-snle_none-sns_blackwhiteL'
        }, {
          title: 'Revolts™ Lens Kits',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'revoltparts-rf_none-rle_greenN-rs_none',
          part: 'rle',
          link: '/shop/parts/revolts?id=revoltparts-rf_none-rle_greenN-rs_none'
        }, {
          title: 'Revolts™ Frames',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'revoltparts-rf_blackM-rle_none-rs_none',
          part: 'rf',
          link: '/shop/parts/revolts?id=revoltparts-rf_blackM-rle_none-rs_none'
        }, {
          title: 'Revolts™ Straps',
          dynamicImg: true,
          viewAngle: 5,
          sku: 'revoltparts-rf_none-rle_none-rs_blackwhiteL',
          part: 'rs',
          link: '/shop/parts/revolts?id=revoltparts-rf_none-rle_none-rs_blackwhiteL'
        }]
      })

      if (this.pageMode === 'paceparts') groups = [...groups, {
        title: 'Conversion Kits',
        subtitle: 'Pace Series™',
        products: [{
          title: 'Vulcans™ TF Conversion Kit',
          subtitle: 'For: Vulcans™ TF & Vulcans™ FF',
          sku: 'vulcansck-vcn_Mblack',
          part: 'vcn',
          dynamicImg: true,
          fixedPrice: true,
          link: '/shop/parts/vulcans?id=vulcansck-vcn_Mblack'
        }, {
          title: 'Vulcans FF Conversion Kit',
          subtitle: 'For: Vulcans™ TF & Vulcans™ FF',
          sku: 'vulcansck-vcb_Mblack',
          part: 'vcb',
          dynamicImg: true,
          fixedPrice: true,
          link: '/shop/parts/vulcans?id=vulcansck-vcb_Mblack'
        }, {
          title: 'Velans™ TF Conversion Kit',
          subtitle: 'For: Velans™ TF & Velans™ FF',
          sku: 'velansck-ven_Mblack',
          part: 'ven',
          dynamicImg: true,
          fixedPrice: true,
          link: '/shop/parts/velans?id=velansck-ven_Mblack'
        }, {
          title: 'Velans™ FF Conversion Kit',
          subtitle: 'For: Velans™ TF & Velans™ FF',
          sku: 'velansck-veb_Mblack',
          part: 'veb',
          dynamicImg: true,
          fixedPrice: true,
          link: '/shop/parts/velans?id=velansck-veb_Mblack'
        }, {
          title: 'Airas™ ZF Conversion Kit',
          subtitle: 'For: Airas™ ZF & Airas™ BF',
          sku: 'airasck-an_Mblack',
          part: 'an',
          dynamicImg: true,
          fixedPrice: true,
          link: '/shop/parts/airas?id=airasck-an_Mblack'
        }, {
          title: 'Airas™ BF Conversion Kit',
          subtitle: 'For: Airas™ ZF & Airas™ BF',
          sku: 'airasck-ab_Mblack',
          part: 'ab',
          dynamicImg: true,
          fixedPrice: true,
          link: '/shop/parts/airas?id=airasck-ab_Mblack'
        }]
      }, {
        title: 'Lens Kits',
        subtitle: 'Pace Series™',
        products: [{
          title: 'Vulcans™ Lens Kits',
          subtitle: 'For: Vulcans™ TF & Vulcans™ FF',
          sku: 'vulcanslrk-vcle_8fire',
          part: 'vcle',
          dynamicImg: true,
          link: '/shop/lenses/vulcans'
        }, {
          title: 'Velans™ Lens Kits',
          subtitle: 'For: Velans™ TF && Velans™ FF',
          sku: 'velanslrk-vele_8fire',
          part: 'vele',
          dynamicImg: true,
          link: '/shop/lenses/velans'
        }, {
          title: 'Airas™ Lens Kits',
          subtitle: 'For: Airas™ TF & Airas™ FF',
          sku: 'airaslrk-ale_8fire',
          part: 'ale',
          dynamicImg: true,
          link: '/shop/lenses/airas'
        }]
      }]

      if (this.pageMode === 'limitededition') {
        groups.push({
          leMode: true,
          title: 'Limited Edition',
          subtitle: 'Featuring exclusive combinations and design details, SunGod Limited Edition models are released every couple of months and sell out quick. Make sure you are the first to know about our next Limited Edition release by signing up for our mailing list at the bottom of the page!',
          products: this.$store.getters['product/limitedEditions']
        })
        groups.push({
          leMode: true,
          title: 'Signature Series',
          subtitle: 'Designed in collaboration with our Pro Team athletes, SunGod Signature Series models are inspired by action sports and feature exclusive design details from the athletes who helped to create them. Featuring the latest SunGod 4K Optics<sup>®</sup> lenses, our SunGod Signature Series combine an enhanced optical experience with the unique style of some of the most inspiring athletes in the world.',
          products: this.$store.getters['product/signatureSeries']
        })
      }

      if (this.pageMode === 'signatureseries') {
        groups.push({
          leMode: true,
          title: 'Signature Series',
          subtitle: 'Designed in collaboration with our Pro Team athletes, SunGod Signature Series models are inspired by action sports and feature exclusive design details from the athletes who helped to create them. Featuring the latest SunGod 4K Optics<sup>®</sup> lenses, our SunGod Signature Series combine an enhanced optical experience with the unique style of some of the most inspiring athletes in the world.',
          products: this.$store.getters['product/signatureSeries']
        })
        groups.push({
          leMode: true,
          title: 'Limited Edition',
          subtitle: 'Featuring exclusive combinations and design details, SunGod Limited Edition models are released every couple of months and sell out quick. Make sure you are the first to know about our next Limited Edition release by signing up for our mailing list at the bottom of the page!',
          products: this.$store.getters['product/limitedEditions']
        })
      }

      return groups
    }
  },

  methods: {
    getLimitedEditionProductName (product) {
      let name = product.name || (product.product || {}).name
      name = name.replace(/Signature Series/ig, 'SS')
      name = name.replace(/Limited Edition/ig, 'LE')
      name = name.replace('McLaren', '<span class="normal-case">Mc</span>Laren')
      return name
    }
  }
}
